<template>

  <div>
      
    <div id="preview">
      <img :src="results['logofile']" />
    </div>
    
    <section>

    <h2> Please review and submit your information </h2>

      <hr />

      <b-container class="bv-example-row">

        <b-row>

          <b-col cols="8">
          
            <section>

              <h3>Company information</h3>

              <hr/>
              <div class="ml-4">
              <div class="row">
                <div class='col-4'>
                  <div>
                    <label class="control-label" for="name"><strong>Company Name</strong></label>
                  </div>
                </div>
                <div class='col-8'>{{results['comp_name']}}</div>
              </div>

              <div class="row">
                <div class='col-4'>
                  <div>
                    <label class="control-label" for="name"><strong>Phone</strong></label>
                  </div>
                </div>
                <div class='col-8'>{{results['phone']}}</div>
              </div>

              <div class="row">
                <div class='col-4'>
                  <div>
                    <label class="control-label" for="name"><strong>Fax</strong></label>
                  </div>
                </div>
                <div class='col-8' v-if="results['fax']">
                  {{results['fax']}}  
                </div>
                <div class='col-8 text-muted' v-else>None</div>
              </div>

              <div class="row">
                <div class='col-4'>
                  <div>
                    <label class="control-label" for="name"><strong>Email</strong></label>
                  </div>
                </div>
                <div class='col-8'>{{results['email']}}</div>
              </div>

              <div class="row">
                <div class='col-4'>
                  <div>
                    <label class="control-label" for="name"><strong>Address</strong></label>
                  </div>
                </div>
                <div class='col-8'>
                  <div>{{results['addr_line1']}}</div>
                  <div v-if="results['addr_line2']">{{results['addr_line2']}}</div>
                  <div>{{results['city']}} , {{results['state']}}</div>
                  <div>{{results['zip']}}</div>
                  <div>{{results['country']}}</div>
                </div>  
              </div>
                
            </div>
            </section>  

            <section class="mt-4">

              <h3>Instance information</h3>
              <hr/>
              <div class="ml-4">
              <div class="row">
                <div class='col-4'>
                  <div>
                    <label class="control-label" for="name"><strong>Subdomain</strong></label>
                  </div>
                </div>
                <div class='col-8'>{{results['subdomain']}}<span class="text-muted">.smartbilling.ca</span></div>
              </div>

              <div class="row">
                <div class='col-4'>
                  <div>
                    <label class="control-label" for="name"><strong>Administrator Name</strong></label>
                  </div>
                </div>
                <div class='col-8'>
                  <div>{{results['full_name']}}</div>
                  <div>{{results['user_email']}}</div>
                </div>  
              </div>

              <div class="row mt-4" v-if="!forclearlyip">
                <div class='col-4'>
                  <div>
                    <label class="control-label" for="name"><strong>Markets</strong></label>
                  </div>
                </div>
                <div class='col-8' v-if="results['market'] && results['market'].length">
                  <div v-for="item in results['market']" :key="item">{{item}}</div>  
                </div>
                <div class='col-8 text-muted' v-else>None</div>
              </div>

              <div class="row" v-if="!forclearlyip">
                <div class='col-4'>
                  <div>
                    <label class="control-label" for="name"><strong>Plans</strong></label>
                  </div>
                </div>
                <div class='col-8' v-if="results['plans'] && results['plans'].length">
                  <div v-for="item in results['plans']" :key="item">{{item}}</div>
                </div>   
                <div class='col-8 text-muted' v-else>None</div> 
              </div>

              <div class="row mt-2" v-if="forclearlyip">
                <div class='col-4'>
                  <div>
                    <label class="control-label" for="name"><strong>Tax Jurisdiction</strong></label>
                  </div>
                </div>
                <div class='col-8'>
                  <div>{{results['tax_code']}}</div>
                </div>  
              </div>

              <div class="row" v-if="results['compliance_access_code']">
                <div class='col-4'>
                  <div>
                    <label class="control-label" for="name"><strong>Compliance Access Code</strong></label>
                  </div>
                </div>
                <div class='col-8'>
                  {{results['compliance_access_code']}}  
                </div>
              </div>

              </div>

            </section>
          
          </b-col>

          <b-col cols="4">
            <b-img :src="require('./assets/images/slide-04.png')" fluid alt="smartbox smartbilling"></b-img>
          </b-col>
      
        </b-row>
  
      </b-container>

    </section>

  </div>

</template>

<script>

export default {
  name: 'StepConfirm',
  props: ['results'],
  data() {
    return {
      forclearlyip: false,
      currentUrl: location.toString()
    }
  },
  mounted() {
      this.forclearlyip = this.currentUrl.includes("clearlyip");
      //console.log(this.results['compliance_access_code']);
  },   
  validations: {
  },
  methods: {
    validate() {
      return true
    }    
  }
}
</script>


// WEBPACK FOOTER //
// src/StepConfirm.vue